// important that all of these are lowercase
export const childFilter = [
  "637404",
  "abi-coley",
  "academy",
  "adam-barradell",
  "adedeji",
  "aideed",
  "alfie-fisken",
  "alpha-diallo",
  "aluko",
  "alves",
  "amani-richards",
  "amartey",
  "amber-faulkner",
  "amya-hammond",
  "andreou",
  "andy-king",
  "arjan-raikhy",
  "bade-aluko",
  "baker",
  "barradell",
  "bausor",
  "beare",
  "bell",
  "ben-grist",
  "beth-slater",
  "birks",
  "bismark-owusu",
  "bobby-amartey",
  "bowen",
  "boy",
  "briggs",
  "carney",
  "cartwright",
  "chalmers",
  "charity",
  "chris-popov",
  "chris-tucker",
  "christos-andreou",
  "colebourne",
  "coley",
  "community",
  "connah-chalmers",
  "contact",
  "crista-chetcuti-ganado",
  "dei",
  "deniche-hill",
  "denny",
  "diallo",
  "discrimination",
  "donnelly",
  "donohue",
  "dowsett",
  "draper",
  "dyke",
  "ed-holden",
  "education",
  "emmie-birks",
  "engage",
  "equality",
  "evans",
  "events",
  "ewing",
  "faulkner",
  "ffion-bowen",
  "filbert",
  "fisken",
  "fletcher",
  "football-for-all",
  "foundation",
  "french",
  "freya-pearce",
  "ganado",
  "gibson",
  "girl",
  "godsmark-ford",
  "golding",
  "gracie-smith",
  "gray",
  "grist",
  "groves",
  "hammond",
  "hannah-beare",
  "harriett-wayne",
  "harry-french",
  "harry-jacklin",
  "harvey-godsmark-ford",
  "health",
  "henry-cartwright",
  "hill",
  "holden",
  "hollis",
  "hugo-de-lisle",
  "inclusion",
  "jacklin",
  "jahmari-lindsay",
  "jake-donohue",
  "jake-evans",
  "jake-fletcher",
  "james",
  "jayden-joseph",
  "jenna-whinney",
  "jeremy-monga",
  "joe-wormleighton",
  "joseph",
  "josh-king",
  "jude-kutshienza",
  "junior",
  "kaczmar",
  "kaleb-dyke",
  "kevon-gray",
  "khela",
  "kian-pennant",
  "kiera-bell",
  "king",
  "kirsten-otchere",
  "kutshienza",
  "laolu-omobolaji",
  "las",
  "lawrence",
  "leicester-city-in-the-community",
  "leon-mcsweeney",
  "lewis-mcnab",
  "liam-mcalinney",
  "lindsay",
  "lisle",
  "logan-briggs",
  "louis-page",
  "louis-sowe",
  "lucy-carney",
  "lucy-pugh",
  "luqman-aideed",
  "manyumba",
  "mark-maxwell",
  "matchday-experiences",
  "matt-rains",
  "maxwell",
  "mcalinney",
  "mcnab",
  "mcsweeney",
  "medical-provision",
  "michael-golding",
  "michael-toko",
  "mirsad-ali",
  "monga",
  "neale",
  "nelly-las",
  "olabade-aluko",
  "oli-ewing",
  "ollie-colebourne",
  "omobolaji",
  "onanaye",
  "otchere",
  "overview",
  "owusu",
  "page",
  "pearce",
  "pennant",
  "phoebe-baker",
  "player-registration",
  "policy",
  "popov",
  "poppy-groves",
  "primary-stars",
  "profile",
  "pugh",
  "quinn",
  "raikhy",
  "rains",
  "rebekah-dowsett",
  "reiss-khela",
  "richards",
  "romy-saunders",
  "ryan-donnelly",
  "safeguarding",
  "sam-james",
  "sammy-kaczmar",
  "sarah-quinn",
  "saunders",
  "savannah-hollis",
  "sherwood",
  "simone-sherwood",
  "slater",
  "smith",
  "sowe",
  "stevie-bausor",
  "stories",
  "tanashe-manyumba",
  "thomas",
  "toby-onanaye",
  "toko",
  "tom-gibson",
  "tom-wilson-brown",
  "tommy-neale",
  "toure",
  "tristian-thomas",
  "tucker",
  "u11",
  "u12",
  "u13",
  "u14",
  "u15",
  "u16",
  "u17",
  "u18",
  "u19",
  "u20",
  "u21",
  "under-11",
  "under-12",
  "under-13",
  "under-14",
  "under-15",
  "under-16",
  "under-17",
  "under-18",
  "under-19",
  "under-20",
  "under-21",
  "under11",
  "under12",
  "under13",
  "under14",
  "under15",
  "under16",
  "under17",
  "under18",
  "under19",
  "under20",
  "under21",
  "united",
  "vs-foundation",
  "wayne",
  "whinney",
  "will-alves",
  "will-lawrence",
  "wilson-brown",
  "wormleighton",
  "yassine-toure",
  "young",
];

export function includesChildFilteredSubstring(s: string) {
  if (!s) {
    return false;
  }
  s = s.toLowerCase();
  return !!childFilter.find((s2) => s2 && s.includes(s2));
}

export function includesChildFilteredVariable(params: Record<string, any>) {
  return [8755, 8879, 12940].some((id) => id == params?.['teamID']);
}
